/**
 * Shared responsive layout primitives for admin, teacher, student, and public pages.
 */
import { Box } from "@mui/material";

export {
    ResultsPageContainer as PageContainer,
    ResultsPageHeader as PageHeader,
    ResultsSectionPaper as SectionPaper,
    ResponsiveTableWrap,
} from "../pages/admin/examRelated/resultsUi";

/** Horizontal scroll for wide tables on small screens. */
export function TableScroll({ children, sx }) {
    return (
        <Box
            sx={{
                width: "100%",
                maxWidth: "100%",
                overflowX: "auto",
                WebkitOverflowScrolling: "touch",
                ...sx,
            }}
        >
            {children}
        </Box>
    );
}
